<template>
  <section class="app-main">
    <router-view :key="$route.fullPath"></router-view>
  </section>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.app-main {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 30px 20px 30px;
}
</style>
